// functions/lib/ugc/replyDeadline.ts
//
// Échéance de notre réponse à ce que la personne nous envoie : une idée en relecture (promise sous
// UGC_RULES.ideaReplyHours, spec § 5.3) ou un brouillon (repère interne UGC_RULES.draftReplyHours,
// jamais annoncé à la personne). Seul endroit où se calcule cette échéance : la file de l'admin,
// l'e-mail du matin et le portail la lisent ici. La date d'envoi est l'entrée de la vidéo dans son
// état (`updated_at`), qu'une modification de l'idée avant relecture ne change pas.

import { parisDate } from '../report/dates'
import { UGC_RULES } from './rules'

const HOUR_MS = 3_600_000

function plusHours(submittedAt: string, hours: number): string {
  return new Date(Date.parse(submittedAt) + hours * HOUR_MS).toISOString()
}

/** Échéance passée : la réponse est en retard. */
export function isPastDeadline(deadline: string, now: Date): boolean {
  return now.getTime() >= Date.parse(deadline)
}

/** Échéance d'une idée en relecture : l'instant (ISO), son jour à Paris (AAAA-MM-JJ) et le retard. */
export type IdeaReply = { deadline: string; parisDay: string; late: boolean }

export function ideaReply(submittedAt: string, now: Date): IdeaReply {
  const deadline = plusHours(submittedAt, UGC_RULES.ideaReplyHours)
  return { deadline, parisDay: parisDate(new Date(deadline)), late: isPastDeadline(deadline, now) }
}

/** Échéance de la relecture d'un brouillon envoyé à `submittedAt` (repère de l'équipe). */
export function draftReplyDeadline(submittedAt: string): string {
  return plusHours(submittedAt, UGC_RULES.draftReplyHours)
}
